import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight, IconAlertCircle } from '@iwoca/icons';
import { Modal } from '@iwoca/orion';

export const SellerDirectoryBannerTest = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(true);
    tracking.ampli.sellerDirectoryButtonClicked();
  };

  return (
    <div className="my-xs box-border flex w-full items-start justify-start gap-s rounded-s border border-solid border-secondary-90 px-l py-m">
      <IconAlertCircle className="h-[24px] w-[24px] shrink-0 fill-primary-40" />
      <div className="flex flex-col-reverse gap-0 sm:flex-col sm:gap-s">
        <div className="font-bold">
          Want to know where else you can use iwocaPay?
        </div>
        <button
          onClick={handleClick}
          className="flex cursor-pointer items-center gap-xs border-none bg-transparent px-0 text-s font-bold text-primary-40"
        >
          Find iwocaPay suppliers
          <IconAngleRight fill="#205EAC" className="pt-2xs" />
        </button>
      </div>
      <Modal
        className="text-center"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Send us an email on pay@iwoca.co.uk"
        closeIcon
        headerBar
      >
        <div className="font-reg">
          <div className="font-bold">
            You can use your spending limit with any iwocaPay supplier
          </div>
          <div>
            We're not able to share a complete list of all the suppliers we work
            with just yet, but we're always happy to help you find what you're
            looking for.
          </div>
          <div className="pt-xl font-bold">
            Tell us what you're looking to buy
          </div>
          <div>
            We'll send you a list of suppliers who sell it and accept iwocaPay.
          </div>
        </div>
      </Modal>
    </div>
  );
};
